import styled from 'styled-components';

const FilterContainer = styled.div`
  margin: 24px 0px 16px 0px;
`;

const DivisionLine = styled.div`
  margin: 24px 0px 16px 0px;
  background: #84b1cc;
  width: 100vw;
  margin-left: -16px;
  height: 1px;

  @media (min-width: 640px) {
    width: 100%;
    margin-left: 0;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 24px;

  .clicked {
    background: var(--nb-primary);
    color: #ffffff;
  }

  @media (min-width: 640px) {
    padding-left: 16px;
  }
`;

const FilterButton = styled.button`
  background: #ffffff;
  border-radius: 4px;
  padding: 12px 24px;
  width: fit-content;

  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--nb-primary);

  &:hover {
    cursor: pointer;
    background: var(--primary-hover);
    color: #ffffff;
  }

  &:focus {
    background: var(--nb-primary);
    color: #ffffff;
  }

  &:active {
    background: var(--nb-primary);
    color: #ffffff;
  }
`;

const TagsContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 4px;
  display: flex;
  gap: 8px;
  color: #161d1f;
  align-items: center;

  .clicked {
    background: var(--button-secondary-focus);
  }

  @media (min-width: 640px) {
    padding-left: 16px;
  }
`;

const TagFilterButton = styled.button`
  display: flex;
  gap: 8px;
  background: #ffffff;
  border-radius: 20px;
  padding: 6px 12px 6px 12px;
  color: var(--text-text02);
  border: 1px solid var(--text-secondary);

  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }

  img {
    weight: 16px;
    height: 16px;
  }

  &:hover {
    cursor: pointer;
    background: var(--button-secondary-hover);
  }

  &:focus {
    background: var(--button-secondary-focus);
  }

  &:active {
    background: var(--button-secondary-focus);
  }
`;

const ResultsText = styled.p`
  font-family: 'Lato';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  leading-trim: none;
  letter-spacing: 0px;
  color: #161d1f;
`;

export {
  FilterContainer,
  DivisionLine,
  ButtonsContainer,
  FilterButton,
  TagsContainer,
  TagFilterButton,
  ResultsText
};
